<template>
  <span
    class="inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium bg-[#f0f4e8] text-[#3d5218] ring-1 ring-inset ring-[#5c7a2e]/20"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "SuccessBadge",
  props: ["label"],
};
</script>
